import { createSetCookie, getCookie, removeCookies } from '@cbhq/ucpm-web';

/*
 * cb_rcid carries the requested_identity_account_id (rcid) — the legal entity
 * the user most recently selected in the entity picker. Retail surfaces
 * (frontend/coinbase-www) read it client-side. The retail reader is
 * responsible for the switch-to-self interpretation (e.g. ignoring the cookie
 * when its value equals the current userUuid).
 *
 * Goes through @cbhq/ucpm-web (the unified cookie policy manager). The cookie
 * name must be registered in ucpm-web's identity + coinbase product
 * allowlists; otherwise useRemoveUnauthorizedCookies strips it.
 */

const COOKIE_NAME = 'cb_rcid';
const MAX_AGE_SECONDS = 3600;
const MAX_AGE_DAYS = MAX_AGE_SECONDS / 86400;

const setCbRcid = createSetCookie({ name: COOKIE_NAME, product: 'identity' });

export function deleteRcidCookie(): void {
  removeCookies([COOKIE_NAME]);
}

export function writeRcidCookie(rcid: string): void {
  setCbRcid(rcid, {
    expires: MAX_AGE_DAYS,
    secure: true,
    sameSite: 'lax',
    // Domain is handled by ucpm-web internally via getDomainWithoutSubdomain.
  });
}

/*
 * createSetCookie JSON.stringifies on write (ucpm-web setCookie.ts:48), so
 * the on-disk value is `"<uuid>"` with literal quote characters. JSON.parse
 * recovers the original string. Falls back to the raw value if parsing
 * fails or yields a non-string — defends against a hand-set cookie or a
 * pre-rollout writer that didn't stringify.
 */
export function readRcidCookie(): string | undefined {
  const raw = getCookie(COOKIE_NAME);
  if (!raw) return undefined;
  try {
    const parsed: unknown = JSON.parse(raw);
    return typeof parsed === 'string' ? parsed : raw;
  } catch {
    return raw;
  }
}
